var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.1388 19.1668v-8.3786h2.8205L9.374 7.553H6.1388V5.479c0-.9125.2488-1.5761 1.5761-1.5761H9.457V.9994c-.3318 0-1.3273-.1659-2.4887-.1659-2.4887 0-4.1478 1.4932-4.1478 4.3137V7.553H0v3.2352h2.8205v8.3786h3.3183z"}));
}

Facebook.defaultProps = {"fill":"none","viewBox":"0 0 10 20"};

module.exports = Facebook;

Facebook.default = Facebook;
